import { RecurrenceEnum } from "web_myplann/Infrastructure/Api/Api";

export const SELECTABLE_RECURRENCES = Object.values(RecurrenceEnum);
